mutation upgradeToExpert($input: UpgradeToExpertInput!) {
  upgradeToExpert(input: $input)
}
